import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Heading from '../components/heading/heading';
import axios from '../backendService';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  Modal,
  Radio,
  Space,
  TimePicker,
  Tooltip,
  message,
} from 'antd';
import { FaRegEdit, FaPoll } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import moment from 'moment';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IoMdArrowRoundBack } from 'react-icons/io';

const SessionPolls = () => {
  const { videoId } = useParams();
  const [videoObj, setVideoObj] = useState({});
  const [sessionPolls, setSessionPolls] = useState([]);
  const [currentPublishDate, setCurrentPublishDate] = useState(null);
  const [currentStartTime, setCurrentStartTime] = useState(null);
  const [currentEndTime, setCurrentEndTime] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  // For modal
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  // to close modal
  const onCancel = () => {
    setOpen(false);
  };

  // generate letter index for options
  // const indexToLetter = (index) => String.fromCharCode(65 + index);

  const handleRefresh = () => {
    window.location.reload();
  };

  // Fetch video data when page loads
  const fetchData = async () => {
    try {
      const response = await axios.get(`/videos/${videoId}`);
      const videoData = response.data;
      setVideoObj(videoData.video);
      if (videoData.video.videoPolls) {
        setSessionPolls(videoData.video.videoPolls);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const publishDate = moment(videoObj.publishDate);
    setCurrentPublishDate(publishDate);
    const startTime = moment(videoObj.startTime, 'HH:mm');
    setCurrentStartTime(startTime);
    const endTime = moment(videoObj.endTime, 'HH:mm');
    setCurrentEndTime(endTime);
  }, [videoObj]);

  useEffect(() => {
    console.log('sessionPolls', sessionPolls);
  }, [sessionPolls]);

  const handleDeletePoll = async (pollId) => {
    console.log(pollId);
    try {
      const response = await axios.delete(`video-polls/deletePoll/${videoId}/${pollId}`);
      console.log(response.data);
      message.info('Poll deleted');
      fetchData();
    } catch (error) {
      console.error('Error deleting poll', error);
    }
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);

    let optionsArr = [];
    values.options.map((item) => {
      const optionToPush = { option: item, count: 0 };
      optionsArr.push(optionToPush);
    });

    try {
      const response = await axios.post(`video-polls/addPoll`, {
        question: values.question,
        answer: values.answer,
        options: optionsArr,
        popupTime: form.getFieldValue('popupTime').format('HH:mm:ss'),
        runningTime: form.getFieldValue('runningTime').format('mm:ss'),
        lecture: videoId,
      });
      form.resetFields();
      message.success('Poll created');
      fetchData();
      onCancel();
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
    }
  };

  return (
    <>
      <div className="px-6 pb-10 flex flex-col items-start justify-start gap-4 bg-white">
        <div className="pt-5 w-full flex items-center justify-start">
          <Button
            type="primary"
            icon={<IoMdArrowRoundBack />}
            size={'large'}
            className="text-sm text-blue-700 gap-2 flex items-center justify-start"
            onClick={goBack}
          >
            Get back
          </Button>
        </div>
        {/* Title */}
        <Heading as="h4" className="text-dark dark:text-white87 text-[22px] font-semibold mt-2">
          Create / Update Polls
        </Heading>

        {/* Video Data */}
        <Space size={'large'} className="mt-2" wrap>
          <p>Course: {videoObj && videoObj.course && videoObj.course.courseName}</p>
          <p>Subject: {videoObj && videoObj.subject && videoObj.subject.subjectName}</p>
          <p>Chapter: {videoObj && videoObj.chapter && videoObj.chapter.chapterName}</p>
          <p>Topic: {videoObj && videoObj.topic && videoObj.topic.topicName}</p>
        </Space>

        {/* Time data */}
        <Space
          size={'middle'}
          direction={'vertical'}
          wrap
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div className="flex items-center justify-between flex-wrap">
            <Heading as="h5" className="text-dark dark:text-white87 text-[22px] font-semibold mb-0">
              Scheduled time
            </Heading>
          </div>
          <Space size={'large'} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} wrap>
            <DatePicker
              disabled
              disabledDate={(current) => {
                return current && current < moment().startOf('day');
              }}
              value={currentPublishDate}
              placeholder="Schedule date"
            />
            <TimePicker
              disabled
              format={'HH:mm'}
              value={currentStartTime}
              onChange={(e) => setCurrentStartTime(e.target.value)}
              placeholder="Start time"
            />
            <TimePicker
              disabled
              format={'HH:mm'}
              onChange={(e) => setCurrentStartTime(e.target.value)}
              value={currentEndTime}
              placeholder="End time"
            />
          </Space>
        </Space>

        {/* Polls data (current or new) */}
        <div className="flex w-full items-center justify-between flex-wrap mt-2">
          <Heading as="h5" className="text-dark dark:text-white87 text-[22px] font-semibold mb-0">
            Polls Data
          </Heading>
          <Button
            type="primary"
            icon={<FaPoll />}
            size={'large'}
            className="text-sm text-blue-700 gap-2 flex items-center justify-start"
            onClick={() => setOpen(!open)}
          >
            Add Poll
          </Button>
        </div>
        <Space
          size={'middle'}
          wrap
          style={{
            display: 'flex',
          }}
        >
          {sessionPolls.length === 0 ? (
            <div className="w-full flex items-center justify-center">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            sessionPolls.map((item, index) => (
              <Card
                key={index}
                size="medium"
                title={
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <span>
                      <p className="mb-0 text-sm">{item.question}</p>
                    </span>
                    <Tooltip title="Delete" className="cursor-pointer">
                      <MdDelete onClick={() => handleDeletePoll(item._id)} color="red" />
                    </Tooltip>
                  </div>
                }
                bordered={true}
              >
                <Space
                  size={'small'}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'start',
                  }}
                  wrap
                >
                  <Space size={'small'} direction={'vertical'}>
                    {item.options.map((option, i) => (
                      <Tooltip key={i} title={option.option}>
                        <span
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block',
                            minWidth: '200px',
                            maxWidth: '200px',
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '20px',
                          }}
                        >
                          <span className="w-16">{option.option}</span>
                          <span className=" text-green-500">count: {option.count}</span>
                        </span>
                      </Tooltip>
                    ))}
                  </Space>
                  <Space size={'small'} direction={'vertical'}>
                    <p>Popup time: {item.popupTime}</p>
                    <p>Runtime: {item.runningTime}</p>
                  </Space>
                </Space>
              </Card>
            ))
          )}
        </Space>
      </div>
      <Modal
        style={{ top: 20 }}
        open={open}
        title="Add new poll"
        okText="Create"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              console.log(values);
              handleFormSubmit(values);
              // form.resetFields();
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form
          disabled={loading}
          form={form}
          layout={'horizontal'}
          name="poll_form"
          initialValues={{ options: ['', ''] }}
        >
          <Form.Item name="question" rules={[{ required: true, message: 'Please enter the question' }]}>
            <Input disabled={loading} placeholder="Enter the question." />
          </Form.Item>
          <Form.List
            name="options"
            rules={[
              {
                validator: async (_, options) => {
                  if (!options || options.length < 2) {
                    return Promise.reject(new Error('At least two options are required.'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Space
                    key={key}
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                    align="baseline"
                    className="w-full"
                  >
                    <Form.Item
                      {...restField}
                      name={[name]}
                      style={{ display: 'flex', flex: 1 }} // Ensure the Form.Item takes the full width
                      rules={[{ required: true, message: 'Option is required' }]}
                    >
                      <Input
                        prefix={`${index + 1}.`}
                        placeholder="Option"
                        style={{ width: '100%' }} // Ensure the input takes the full width of the Form.Item
                      />
                    </Form.Item>
                    {index !== 0 && index !== 1 && <MinusCircleOutlined onClick={() => remove(name)} />}
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    disabled={fields.length === 5}
                  >
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Form.Item
            name="answer"
            rules={[
              { required: true, message: 'Please enter correct option index. eg. 1' },
              {
                pattern: /^[1-5]$/, // regular expression to allow only single digit integer (1-9)
                message: 'Please enter correct option index. eg. 1',
              },
            ]}
          >
            <Input
              disabled={loading}
              max={9}
              maxLength={1}
              placeholder="Enter the answer index number."
              onChange={(e) => {
                // Enforce the value to be a single digit integer (1-9)
                e.target.value = (e.target.value.match(/^[1-5]$/) || []).pop() || '';
              }}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%' }}
            name="popupTime"
            rules={[
              {
                required: true,
                message: 'Please enter pop-up-time',
              },
            ]}
          >
            <TimePicker disabled={loading} style={{ width: '100%' }} placeholder="Enter popup time" />
          </Form.Item>
          <Form.Item
            style={{ width: '100%' }}
            name="runningTime"
            rules={[
              {
                required: true,
                message: 'Please enter running time',
              },
            ]}
          >
            <TimePicker
              disabled={loading}
              style={{ width: '100%' }}
              format={'mm:ss'}
              placeholder="Enter running time"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default SessionPolls;
